/**
 * The code exports custom hooks that utilize the useContext hook to access different contexts in a
 * React application.
 * @returns The code snippet is defining four custom hooks: `useSetting`, `useMui`, `useGobalContext`,
 * and `useBootstrap`. Each of these hooks uses the `useContext` hook from React to access the
 * corresponding context provided by the context providers.
 */
import { useContext } from "react";
import {
  MuiContext,
  GobalContext,
  BootstrapContext,
  SettingContext,
} from "../context/Context";

function useSetting() {
  return useContext(SettingContext);
}

function useMui() {
  return useContext(MuiContext);
}

function useGobalContext() {
  return useContext(GobalContext);
}

function useBootstrap() {
  return useContext(BootstrapContext);
}

export { useSetting, useMui, useGobalContext, useBootstrap };
